import { useDispatch, useSelector } from "react-redux";

import { useEffect, useState } from "react";
import { setRefreshTable } from "../../../../Redux/Reducers/VariousVariables";
import { GetAllTG_TargetedGroupAge } from "../../../../Redux/Reducers/ProjectInformationPage/InformationAboutTheTargetGroupOfTheProject/DropDownForTargetGroupAge";
import AddTargetInfo from "../../../../Services/ProjectInformationPage/InformationAboutTheTargetGroup/AddInformationAboutTargetGroup";
import $ from "jquery";
import UpdateInformationAboutTheTargetGroup from "../../../../Services/ProjectInformationPage/InformationAboutTheTargetGroup/UpdateInformationAboutTheTargetGroup";
import {
  GetOneInformationAboutTheTargetGroupOfTheProject,
  resetValidateList,
  ValidateInformationAboutTheTargetGroupOfTheProject,
} from "../../../../Redux/Reducers/ProjectInformationPage/InformationAboutTheTargetGroupOfTheProject/indexOne";
import LoaderAHSF from "../../../../Components/LoaderAHSF";
import ButtonAHSF from "../../../../Components/ButtonAHSF";
import TextAreaAHSF from "../../../../Components/TextAreaAHSF";
import AllDropDownsAHSF from "../../../../Components/AllDropDownsAHSF";
import InputAHSF from "../../../../Components/InputAHSF";
import Swal from "sweetalert2";

const AddEditInformationTargetGroup = (props) => {
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      DropDownTargetedGroupAge:
        state.DropDownTargetedGroupAge.DropDownTargetedGroupAge,
      TargetInfo: state.TargetInfo.TargetInfo,
      OneInformationAboutTheTargetGroupOfTheProject:
        state.OneInformationAboutTheTargetGroupOfTheProject
          .OneInformationAboutTheTargetGroupOfTheProject,
      OneInformationAboutTheTargetGroupOfTheProjectloading:
        state.OneInformationAboutTheTargetGroupOfTheProject
          .loadingOneInformationAboutTheTargetGroupOfTheProject,
      tG_mainTargetedGroupId:
        state.TargetInfo.TargetInfo.tG_MainTargetedGroupId,

      OneInformationAboutTheTargetGroupOfTheProjectValidate:
        state.OneInformationAboutTheTargetGroupOfTheProject
          .OneInformationAboutTheTargetGroupOfTheProjectValidate,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
    };
  });
  const [tG_TargetedGroupAge, settG_TargetedGroupAge] = useState([
    {
      DropDownTargetedGroupAge:
        state.DropDownTargetedGroupAge?.tG_TargetedGroupAgeId,
    },
  ]);
  // State for managing the form fields related to the target group
  const [InformationTargetGroupList, setInformationTargetGroupList] = useState({
    tG_TargetedGroupId:
      state.OneInformationAboutTheTargetGroupOfTheProject?.tG_TargetedGroupId,
    myPNatureOfTargetedGrouproperty:
      state.OneInformationAboutTheTargetGroupOfTheProject
        ?.myPNatureOfTargetedGrouproperty,
    tG_TargetedGroupAgeId:
      state.OneInformationAboutTheTargetGroupOfTheProject
        ?.tG_TargetedGroupAgeId,
    expectedNumberOfBeneficiaries:
      state.OneInformationAboutTheTargetGroupOfTheProject
        ?.expectedNumberOfBeneficiaries,
    additionalInformation:
      state.OneInformationAboutTheTargetGroupOfTheProject
        ?.additionalInformation,
    tG_MainTargetedGroupId: state.tG_mainTargetedGroupId,
  });

  //console.log(
  //   state.OneInformationAboutTheTargetGroupOfTheProject
  //     ?.expectedNumberOfBeneficiaries,
  //   "qasem"
  // );

  useEffect(() => {
    //console.log(state.tG_mainTargetedGroupId, "state");
    dispatch(GetAllTG_TargetedGroupAge());
  }, []);

  // const AddInformationTargetGroup = async () => {
  //   await AddTargetInfo(
  //     InformationTargetGroupList.myPNatureOfTargetedGrouproperty,
  //     InformationTargetGroupList.tG_TargetedGroupAgeId,
  //     InformationTargetGroupList.expectedNumberOfBeneficiaries,
  //     InformationTargetGroupList.additionalInformation,
  //     state.tG_mainTargetedGroupId
  //   );
  //   $(".close-btn").trigger("click");
  //   dispatch(setRefreshTable());
  // };
  // Format numbers with commas for better readability
  const numberWithCommas = (x) => {
    x = x != undefined ? x : "";
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  // Function to handle adding target group information
  const AddInformationTargetGroup = async () => {
    const validationList = await dispatch(
      ValidateInformationAboutTheTargetGroupOfTheProject({
        myPNatureOfTargetedGrouproperty:
          InformationTargetGroupList.myPNatureOfTargetedGrouproperty,
        tG_TargetedGroupAgeId: InformationTargetGroupList.tG_TargetedGroupAgeId,
        expectedNumberOfBeneficiaries:
          InformationTargetGroupList.expectedNumberOfBeneficiaries,
        additionalInformation: InformationTargetGroupList.additionalInformation,
      })
    );
    //console.log(validationList, validationList.payload.length, "bnbnmbnmb");
    // If validation passes (no errors)
    if (validationList.payload.length === 0) {
      await AddTargetInfo(
        InformationTargetGroupList.myPNatureOfTargetedGrouproperty,
        InformationTargetGroupList.tG_TargetedGroupAgeId,
        InformationTargetGroupList.expectedNumberOfBeneficiaries,
        InformationTargetGroupList.additionalInformation,
        state.tG_mainTargetedGroupId
      );
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم اضافة المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      dispatch(setRefreshTable());
    }
  };
  // Function to handle updating target group information
  const UpdateTargetInfo = async () => {
    const validationList = await dispatch(
      ValidateInformationAboutTheTargetGroupOfTheProject({
        myPNatureOfTargetedGrouproperty:
          InformationTargetGroupList.myPNatureOfTargetedGrouproperty,
        tG_TargetedGroupAgeId: InformationTargetGroupList.tG_TargetedGroupAgeId,
        expectedNumberOfBeneficiaries:
          InformationTargetGroupList.expectedNumberOfBeneficiaries,
        additionalInformation: InformationTargetGroupList.additionalInformation,
      })
    );
    // If validation passes (no errors)
    if (validationList.payload.length === 0) {
      await UpdateInformationAboutTheTargetGroup(
        InformationTargetGroupList.tG_TargetedGroupId,

        InformationTargetGroupList.myPNatureOfTargetedGrouproperty,
        InformationTargetGroupList.tG_TargetedGroupAgeId,

        InformationTargetGroupList.expectedNumberOfBeneficiaries,
        InformationTargetGroupList.additionalInformation,
        InformationTargetGroupList.tG_MainTargetedGroupId
      );
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم تعديل المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      dispatch(setRefreshTable());
    }
  };
  useEffect(() => {
    dispatch(resetValidateList());
  }, []);
  useEffect(() => {
    //console.log(
    //   state.OneInformationAboutTheTargetGroupOfTheProject,
    //   "props.tG_TargetedGroupId"
    // );
    // Fetch specific target group information if props are provided
    if (props != null) {
      dispatch(
        GetOneInformationAboutTheTargetGroupOfTheProject(
          props.tG_TargetedGroupId
        )
      );
    }
  }, [props.tG_TargetedGroupId]);
  // Update local state with fetched target group information
  useEffect(() => {
    if (
      !state.OneInformationAboutTheTargetGroupOfTheProjectloading &&
      Object.keys(props).length != 0
    ) {
      setInformationTargetGroupList({
        ...state.OneInformationAboutTheTargetGroupOfTheProject,
      });
    } else {
      setInformationTargetGroupList({
        tG_TargetedGroupId: null,
        myPNatureOfTargetedGrouproperty: null,
        tG_TargetedGroupAgeId: null,
        additionalInformation: null,
        tG_mainTargetedGroupId: state.tG_mainTargetedGroupId,
        expectedNumberOfBeneficiaries: null,
      });
    }
  }, [state.OneInformationAboutTheTargetGroupOfTheProject]);

  const shouldDisableFields = !(
    state.ApplicationInformation?.aI_ApplicationStatusId == "bbad6edf-0d73-4478-b33d-68f9c777d438"&&!window.location.href.includes("manager") ? true :
      state.ActiveRound === state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      !window.location.href.includes("manager")
  );

  return (
    <>
      {!state.OneInformationAboutTheTargetGroupOfTheProjectloading ? (
        <>
          <div className="AddEdite">
            <TextAreaAHSF
              fieldsName="TypeOfTheTargetGroup"
              show={true}
              disabled={shouldDisableFields}
              onChange={(e) => {
                setInformationTargetGroupList({
                  ...InformationTargetGroupList,
                  myPNatureOfTargetedGrouproperty: e.target.value,
                });
              }}
              defaultValue={
                InformationTargetGroupList.myPNatureOfTargetedGrouproperty
              }
              showValidationMessage={
                state.OneInformationAboutTheTargetGroupOfTheProjectValidate
                  ? state.OneInformationAboutTheTargetGroupOfTheProjectValidate.includes(
                      "TypeOfTheTargetGroup"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />

            <AllDropDownsAHSF
              fieldsName="TargetGroupAge"
              show={true}
              disabled={shouldDisableFields}
              arrayOoptionList={state.DropDownTargetedGroupAge}
              KeyText={"targetedGroupAgeText"}
              KeyValue={"tG_TargetedGroupAgeId"}
              dropdownType={"normal"}
              onChange={(e) => {
                setInformationTargetGroupList({
                  ...InformationTargetGroupList,
                  tG_TargetedGroupAgeId: Number(e.target.value),
                });
              }}
              defaultValue={InformationTargetGroupList.tG_TargetedGroupAgeId}
              showValidationMessage={
                state.OneInformationAboutTheTargetGroupOfTheProjectValidate
                  ? state.OneInformationAboutTheTargetGroupOfTheProjectValidate.includes(
                      "TargetGroupAge"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <InputAHSF
              fieldsName="ExpectedNumberOfBeneficiaries"
              show={true}
              comma={true}
              disabled={shouldDisableFields}
              onChange={(e) => {
                setInformationTargetGroupList({
                  ...InformationTargetGroupList,
                  expectedNumberOfBeneficiaries: e.target.value,
                });
              }}
              defaultValue={numberWithCommas(
                state.OneInformationAboutTheTargetGroupOfTheProject
                  ?.expectedNumberOfBeneficiaries
              )}
              showValidationMessage={
                state.OneInformationAboutTheTargetGroupOfTheProjectValidate
                  ? state.OneInformationAboutTheTargetGroupOfTheProjectValidate.includes(
                      "ExpectedNumberOfBeneficiaries"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />

            <TextAreaAHSF
              fieldsName="OtherInformation"
              show={true}
              disabled={shouldDisableFields}
              onChange={(e) => {
                setInformationTargetGroupList({
                  ...InformationTargetGroupList,
                  additionalInformation: e.target.value,
                });
              }}
              defaultValue={InformationTargetGroupList.additionalInformation}
              showValidationMessage={
                state.OneInformationAboutTheTargetGroupOfTheProjectValidate
                  ? state.OneInformationAboutTheTargetGroupOfTheProjectValidate.includes(
                      "OtherInformation"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            {!shouldDisableFields ? (
              <div className="containersButton">
                <div>
                  <ButtonAHSF
                    type={"submitter"}
                    onClick={() => {
                      props.canEdit == "edit"
                        ? UpdateTargetInfo()
                        : AddInformationTargetGroup();
                    }}
                    disabled={false}
                    title={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                    text={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                    show={true}
                  />
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </>
      ) : (
        ""
      )}
      <LoaderAHSF
        show={state.OneInformationAboutTheTargetGroupOfTheProjectloading}
      />
    </>
  );
};

export default AddEditInformationTargetGroup;
